import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import { isDesktop } from '@/lib/desktop';

const storedTheme = localStorage.getItem('theme') || 'light';
document.documentElement.classList.add(storedTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Fonctionnement sans réseau: les fichiers de l'application sont gardés sur
// l'appareil (service worker). Une nouvelle version s'installe en silence et
// s'utilise à la prochaine ouverture. Hors production, aucun service worker:
// il servirait des fichiers de développement périmés. Dans l'application Windows
// non plus: les fichiers sont déjà sur le disque, la coque les sert et se met à
// jour elle-même (desktop/), un second cache les rendrait périmés.
if ('serviceWorker' in navigator && !isDesktop()) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((enregistrement) => {
          const verifier = () => enregistrement.update().catch(() => {});
          setInterval(verifier, 60 * 60 * 1000);
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') verifier();
          });
        })
        .catch(() => {
          // No-op: SW registration failure should not block app usage.
        });
    });
  } else {
    navigator.serviceWorker
      .getRegistrations()
      .then((liste) => liste.forEach((enregistrement) => enregistrement.unregister()))
      .catch(() => {});
  }
}
